/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {
  bus
} from '@/main';
import {
mapGetters,
} from 'vuex';
import toast from '@/services/toast';
import userAgreement from '@/components/private/ai-dashboard/task-user-agreement-popup/';

export default {
  name: 'ai-info-of-member',
  components: {
    'user-agreement-popup':userAgreement,
  },
  props: [],
  data () {
    return {
      createdAlgoList:null,
      createdAlgoListResults:[],
      pubModelId:'',
      publicModelPopup:false,
      countForAiDash:{},
      recentMostTrainedModelsList:null,
      recentMostTrainedModelsListResults:[],
      userDetails:{},
      selfUserModelsState:true,
      publicUserModelsState:false,
      sharedModelsState:false,
      publicUserModelsList:null,
      publicUserModelsListResults:[],
      search_term:'',
      searchModelsList:[],
      searchModelsListState:false,
      allModelsListState:true,
      historyUserModelsState:false,
      historyUserModelsList:null,
      historyUserModelsListResults:[],
      updateModelNameState:false,
      updateModelName:'',
      updateModelNameId:'',
      submitted:false,
      userPrflPhoto:'',
      userAgreementState:localStorage.getItem('userAgreementState'),
      sharedModelsList:null,
      sharedModelsListResults:[],
      sharedModelPopup:false,
      sharedModelInfo:null,
    }
  },
  computed: {
    ...mapGetters([
      'getModelsListForTeamHeadGetters',
      'getModelCountForTeamHeadGetters',
      'getMostUsedTrainModelForTeamHeadGetters',
      'getUserInfoByIdForTeamHeadGetters',
      'getUserInfoByIdForTeamHeadGetters'
    ]),
    getSelfUserDetailsFun(){
      this.userDetails = this.$store.getters.getUserInfoByIdForTeamHeadGetters.data
      return
    },
    getCreateAlgoListFun(){
      this.createdAlgoList = this.$store.getters.getModelsListForTeamHeadGetters.data;
      return
    },
    setInitialStateOfCreatedAlgoFun(){
      if(this.createdAlgoList != undefined){
        this.createdAlgoListResults =  this.createdAlgoList.results
      }
      return
    },
    getMostTrainedModlesListFun(){
      this.recentMostTrainedModelsList = this.$store.getters.getMostUsedTrainModelForTeamHeadGetters.data;
      return
    },
    setInitialStateOfMostTrainedModlesFun(){
      if(this.recentMostTrainedModelsList != undefined){
        this.recentMostTrainedModelsListResults =  this.recentMostTrainedModelsList.results
      }
      return
    },
    getCountOfAiDashboardFun(){
      this.countForAiDash = this.$store.getters.getModelCountForTeamHeadGetters.data;
      return
    },
    getSelfUserPrflPhotoFun(){
      this.userPrflPhoto = this.$store.getters.getUserInfoByIdForTeamHeadGetters.data
      return
    },
  },
  mounted () {
    this.getCreateAlgoListFun
    this.setInitialStateOfCreatedAlgoFun
    this.getCountOfAiDashboardFun
    this.getMostTrainedModlesListFun
    this.setInitialStateOfMostTrainedModlesFun
    this.getSelfUserDetailsFun
    this.getSelfUserPrflPhotoFun
    if(!this.userAgreementState){
      $('body').addClass('user_agreement_popup')
    }
    bus.$on('userAgreementStateBus', (data) => {
      this.userAgreementState = data;
    });
    bus.$on('modelNotesBus', (data) => {
      this.sharedModelPopup = data
    })
  },
  methods: {
    getAllModelListAgainMethod(){
      this.$store.dispatch('getModelListForAITaskFun')
    },
    validateSearchModelsBeforeSubmit(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          if(this.search_term.length >= 3){
            this.allModelsListState = false
            this.searchModelsListState = true
            this.$store.dispatch('searchModelsForTeamHeadFun', {data:{id:this.$route.params.userID, data:this.search_term}}).then((response) => {
              this.searchModelsList = response.data.data.results
            })
          }else{
            this.searchModelsListState = false
            this.allModelsListState = true
            this.searchModelsList = []
          }
        }
      })
    },
    modelsListDisplayFun(MItems){
      if(MItems === 'created_models'){
        if(this.selfUserModelsState) return;
        this.$store.dispatch('getModelListForTeamHeadFun', {id:this.$route.params.userID}).then((res)=>{
          this.publicUserModelsState = false
          this.historyUserModelsState = false
          this.sharedModelsState = false
          this.selfUserModelsState = true
          })
      }else if(MItems === 'public_models'){
        if(this.publicUserModelsState) return;
        this.$store.dispatch('getPublicModelListForAITaskFun').then((res)=>{
          this.publicUserModelsList = res.data.data
          if(this.publicUserModelsList != null){
            this.publicUserModelsListResults = this.publicUserModelsList.results
          }
          this.selfUserModelsState = false
          this.historyUserModelsState = false
          this.sharedModelsState = false
          this.publicUserModelsState = true
        }).catch((err)=>{})
      }else if(MItems === 'history_models'){
        if(this.historyUserModelsState) return;
        this.$store.dispatch('getHistoryModelForTeamHeadFun', {id:this.$route.params.userID}).then((res)=>{
          this.historyUserModelsList = res.data.data
          if(this.historyUserModelsList != null){
            this.historyUserModelsListResults = this.historyUserModelsList.results
          }
          this.selfUserModelsState = false
          this.publicUserModelsState = false
          this.sharedModelsState = false
          this.historyUserModelsState = true
        }).catch((err)=>{})
      }else if(MItems === 'shared_models'){
        if(this.sharedModelsState) return;
        this.$store.dispatch('getSharedModelForTeamHeadFun', {id:this.$route.params.userID}).then((res)=>{
          this.sharedModelsList = res.data.data
          if(this.sharedModelsList != null){
            this.sharedModelsListResults = this.sharedModelsList.results
          }
          this.selfUserModelsState = false
          this.publicUserModelsState = false
          this.historyUserModelsState = false
          this.sharedModelsState = true
        }).catch((err)=>{})
      }
    },
    makeModelPublicMethod(modelId){
      this.pubModelId = modelId
      this.publicModelPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
    clodesModelPublicPopupMethod(){
      this.pubModelId = ''
      this.publicModelPopup = false
      $('body').removeClass('body_right_scroll_remove')
    },
    userStatusUpdatedFun(userStatus){
      var is_public = userStatus
      if(userStatus == false){
        is_public = true
      }else{
        is_public = false
      }
      // console.log(userStatus, is_public, "User Status CHecking")
      let data = new FormData();
      data.append('is_public', is_public);
      this.$store.dispatch('updateProfileFun', data)
        .then((res) => {
          toast.success(res.data.msg);
          this.getUserDetailsAgain()
        }).catch((err) => {
          toast.error(err.data.user_msg || err.data.data.email);
        })
      return;
    },
    modelNameUpdatePopupOpenFun(modelId,ModelName){
      this.updateModelName = ModelName
      this.updateModelNameId = modelId
      this.updateModelNameState = true
      $('body').addClass('body_right_scroll_remove')
    },
    updateModelNameaBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            name : this.updateModelName
          }
          this.$store.dispatch('updateModelDetailsByIDForAIFun',{data:{data:data,id:this.updateModelNameId}})
            .then((res) => {  
              this.getAllModelListAgainMethod()
              toast.success(res.data.msg);
              this.submitted =  false
              this.closeUpdateModelNamePopup()
            }).catch((err) => {
              this.submitted =  false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
    closeUpdateModelNamePopup(){
      this.updateModelNameState = false
      $('body').removeClass('body_right_scroll_remove')
    },
    sharedModelPopupMethod(modelId){
      this.sharedModelInfo = modelId
      this.sharedModelPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
  },
  watch:{
    getCreateAlgoListFun(){
      return this.$store.getters.getModelsListForTeamHeadGetters
    },
    setInitialStateOfCreatedAlgoFun(){
      if(this.createdAlgoList != null){
        this.createdAlgoListResults =  this.createdAlgoList.results
      }
      return
    },
    getCountOfAiDashboardFun(){
      return this.$store.getters.getModelCountForTeamHeadGetters
    },
    getMostTrainedModlesListFun(){
      return this.$store.getters.getMostUsedTrainModelForTeamHeadGetters;
    },
    setInitialStateOfMostTrainedModlesFun(){
      if(this.recentMostTrainedModelsList != null){
        this.recentMostTrainedModelsListResults =  this.recentMostTrainedModelsList.results
      }
      return
    },
    getSelfUserDetailsFun(){
      return this.$store.getters.getUserInfoByIdForTeamHeadGetters
    },
    getSelfUserPrflPhotoFun(){
      return this.$store.getters.getUserInfoByIdForTeamHeadGetters
    },
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('body_right_scroll_remove')
    $('body').removeClass('user_agreement_popup')
    next();
  },
}